import { render } from "./ViewApprovedRequest.vue?vue&type=template&id=2e4aedd6"
import script from "./ViewApprovedRequest.vue?vue&type=script&lang=js"
export * from "./ViewApprovedRequest.vue?vue&type=script&lang=js"

import "./ViewApprovedRequest.vue?vue&type=style&index=0&id=2e4aedd6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__